/**
 * System-wide theme for Aphenis — single cosmic purple theme.
 * Only applies overrides in dark mode; light mode uses CSS variables from index.css.
 */

export interface SystemTheme {
  id: string;
  name: string;
  variables: Record<string, string>;
}

/** The single default cosmic purple theme — dark mode overrides */
const COSMIC_THEME: SystemTheme = {
  id: 'cosmic',
  name: 'Cosmic Purple',
  variables: {
    '--background': '258 22% 4%',
    '--foreground': '258 8% 93%',
    '--card': '260 25% 7%',
    '--card-foreground': '260 5% 92%',
    '--popover': '260 25% 7%',
    '--popover-foreground': '260 5% 92%',
    '--primary': '263 70% 58%',
    '--primary-foreground': '260 30% 4%',
    '--secondary': '260 18% 11%',
    '--secondary-foreground': '260 5% 88%',
    '--muted': '260 15% 14%',
    '--muted-foreground': '260 10% 55%',
    '--accent': '263 49% 35%',
    '--accent-foreground': '263 70% 73%',
    '--border': '260 15% 13%',
    '--input': '260 18% 11%',
    '--ring': '263 70% 58%',
    '--sidebar-background': '260 25% 6%',
    '--sidebar-foreground': '260 5% 88%',
    '--sidebar-primary': '263 70% 58%',
    '--sidebar-primary-foreground': '260 30% 4%',
    '--sidebar-accent': '260 18% 11%',
    '--sidebar-accent-foreground': '260 5% 88%',
    '--sidebar-border': '260 15% 13%',
    '--sidebar-ring': '263 70% 58%',
  },
};

export function getSystemTheme(): SystemTheme {
  return COSMIC_THEME;
}

/** Apply or clear system theme inline overrides based on dark mode */
export function applySystemTheme(): void {
  const root = document.documentElement;
  const isDark = root.classList.contains('dark');

  if (isDark) {
    // Apply cosmic overrides in dark mode
    for (const [key, value] of Object.entries(COSMIC_THEME.variables)) {
      root.style.setProperty(key, value);
    }
  } else {
    // Clear all inline overrides so light mode CSS variables from index.css take effect
    for (const key of Object.keys(COSMIC_THEME.variables)) {
      root.style.removeProperty(key);
    }
  }
}

/** Call on app startup to restore the theme */
export function initSystemTheme(): void {
  applySystemTheme();
}
